import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  IconButton,
  Alert,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { useApiContext } from "../../../Utils/ApiContext/ApiContext";


const DoctorServices = ({ doctor }) => {
    const { services} = useApiContext();
  const AccessToken = getDecryptedAccessToken();
  const [allServices, setAllServices] = useState([]);
  const [doctorServices, setDoctorServices] = useState([]);
  const [servicePercentages, setServicePercentages] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    fetchData();
  }, [AccessToken,doctor.id]);

  const fetchData = () => {
   
      const uniqueServices = [
        ...new Map(
          services.map((item) => [item["service_no"], item])
        ).values(),
      ];
      setAllServices(uniqueServices);
    

    ApiServices.get(`/apis/default/api/allowedServiceDsicount/${doctor.id}`, {
      Authorization: `Bearer ${AccessToken}`,
    }).then((response) => {
      const servicesWithData = response.data || [];
      setDoctorServices(servicesWithData);

      const percentages = servicesWithData.reduce((acc, service) => {
        acc[service.service_id] = service.percent_off || "";
        return acc;
      }, {});
      setServicePercentages(percentages);
    });
  };

  const handleCheckboxChange = (serviceNo) => (event) => {
    setServicePercentages((prev) => ({
      ...prev,
      [serviceNo]: event.target.checked ? (prev[serviceNo] || "") : undefined,
    }));
  };

  const handlePercentOffChange = (serviceNo) => (event) => {
    setServicePercentages((prev) => ({
      ...prev,
      [serviceNo]: event.target.value,
    }));
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const servicesToAdd = [];
    const servicesToUpdate = [];
    const servicesToRemove = [];

    allServices.forEach((service) => {
      const serviceId = parseInt(service.service_no);
      const isChecked = doctorServices.some(
        (ds) => ds.service_id === serviceId
      );
      const isSelected = servicePercentages[serviceId] !== undefined;

      if (isSelected && !isNaN(servicePercentages[serviceId])) {
        const serviceData = {
          service_id: serviceId,
          subtype_service_id: "",
          percent_off: parseFloat(servicePercentages[serviceId]),
        };

        if (isChecked) {
          servicesToUpdate.push(serviceData);
        } else {
          servicesToAdd.push(serviceData);
        }
      } else if (!isSelected && isChecked) {
        servicesToRemove.push({ service_id: serviceId });
      }
    });

    if (servicesToUpdate.length > 0) {
      try {
        await ApiServices.put(
          `/apis/default/api/allowedServiceDsicount/${doctor.id}`,
          { provider_id: doctor.id, services: servicesToUpdate },
          { Authorization: `Bearer ${AccessToken}` }
        );
        setSnackbar({ open: true, message: "Services updated successfully", severity: "success" });
        setIsSubmitting(false);
        fetchData();
      } catch (error) {
        setSnackbar({ open: true, message: "Error updating services", severity: "error" });
        setIsSubmitting(false);
      }
    }

    if (servicesToAdd.length > 0) {
      try {
        await ApiServices.post(
          `/apis/default/api/allowedServiceDsicount`,
          { provider_id: doctor.id, services: servicesToAdd },
          { Authorization: `Bearer ${AccessToken}` }
        );
        setSnackbar({ open: true, message: "Services added successfully", severity: "success" });
        setIsSubmitting(false);
        fetchData();
      } catch (error) {
        setSnackbar({ open: true, message: "Error adding services", severity: "error" });
        setIsSubmitting(false);
      }
    }

    if (servicesToRemove.length > 0) {
      try {
        await ApiServices.put(
          `/apis/default/api/allowedServiceDsicount/${doctor.id}`,
          { provider_id: doctor.id, services: servicesToRemove },
          { Authorization: `Bearer ${AccessToken}` }
        );
        setSnackbar({ open: true, message: "Services removed successfully", severity: "success" });
        setIsSubmitting(false);
        fetchData();
      } catch (error) {
        setSnackbar({ open: true, message: "Error removing services", severity: "error" });
        setIsSubmitting(false);
      }
    }
  };

  const handleDelete = async () => {
    if (!selectedService) return;
    try {
      await ApiServices.delete(
        `/apis/default/api/masterServices/${selectedService.service_no}/allowedServiceDsicount/${doctor.id}`,
        { Authorization: `Bearer ${AccessToken}` }
      );
      setSnackbar({ open: true, message: "Service deleted successfully", severity: "success" });
      fetchData();
    } catch (error) {
      setSnackbar({ open: true, message: "Error deleting service", severity: "error" });
      setIsSubmitting(false);
    } finally {
      setOpenDialog(false);
      setSelectedService(null);
    }
  };

  const filteredServices = allServices.filter(
    (service) =>
      service.service_no.toString().includes(searchTerm) ||
      service.service.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedServices = filteredServices.sort((a, b) => {
    const aIsAvailable = doctorServices.some(
      (ds) => ds.service_id === parseInt(a.service_no)
    );
    const bIsAvailable = doctorServices.some(
      (ds) => ds.service_id === parseInt(b.service_no)
    );
    return aIsAvailable === bIsAvailable ? 0 : aIsAvailable ? -1 : 1;
  });


  return (
    <Box>
      

      <TextField
        label="Search Services"
        variant="outlined"
        fullWidth
        margin="normal"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <TableContainer component={Paper} style={{ marginTop: 16 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Service No</TableCell>
              <TableCell>Service Name</TableCell>
              <TableCell>Available</TableCell>
              <TableCell>Discount (%)</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedServices.map((service) => {
              const isChecked = servicePercentages[service.service_no] !== undefined;
              const percentOff = servicePercentages[service.service_no] || "";
              const isDoctorService = doctorServices.some(
                (ds) => ds.service_id === parseInt(service.service_no)
              );

              return (
                <TableRow key={service.service_no}>
                  <TableCell>{service.service_no}</TableCell>
                  <TableCell>{service.service}</TableCell>
                  <TableCell>
                    <Checkbox
                      checked={isChecked}
                      onChange={handleCheckboxChange(service.service_no)}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="number"
                      value={percentOff}
                      onChange={handlePercentOffChange(service.service_no)}
                      InputProps={{ inputProps: { min: 0, max: 100 } }}
                      disabled={!isChecked}
                    />
                  </TableCell>
                  <TableCell>
                    {isDoctorService && (
                      <IconButton
                        onClick={() => {
                          setSelectedService(service);
                          setOpenDialog(true);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <Button variant="contained" color="primary" onClick={handleSubmit} disabled={isSubmitting} style={{ marginTop: 16 }}>
        {isSubmitting ? "Submitting..." : "Submit"}
      </Button>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
      >
        <DialogTitle>Delete Service</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the service "{selectedService?.service}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default DoctorServices;
